import { render, staticRenderFns } from "./ControlAccount.vue?vue&type=template&id=740b6c88&scoped=true&"
import script from "./ControlAccount.vue?vue&type=script&lang=ts&"
export * from "./ControlAccount.vue?vue&type=script&lang=ts&"
import style0 from "./ControlAccount.vue?vue&type=style&index=0&id=740b6c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740b6c88",
  null
  
)

export default component.exports